<template>
  <div class='oversea'>
    <div>方法名：GetActivityDetail</div>
    <div>参数暂定：{{activtyData}}</div>
    <div>ActivityType=> 活动类型   0注册   1 维护收货地址</div>
    <div>Status:活动状态=> 0 ：未开始  1：进行中 2：已结束</div>
    <div>Id:活动ID</div>
    <div class="btn" @click="ShippingFee">活动H5按钮</div>
  </div>
</template>
<script>
import bus from '@/api/bus';
export default {
  name: '',
  components: {},
  data() {
    return {
      isPC:false,
      user: { AreaCode: '', Id: '' },
      activtyData:{ActivityType:'',Status:'',Id:''}
    }
  },
  watch: {},
  mounted() {},
  created() {
    bus.$emit('headerTitle', this.$t('title.processIntroduction'));
    this.user.Id = (this.$route.query.Id && this.$route.query.Id != 'undefined') ? this.$route.query.Id : ''
    this.user.AreaCode = (this.$route.query.AreaCode && this.$route.query.AreaCode != 'undefined') ? this.$route.query.AreaCode : ''
    this.getCacheById()
  },
  methods: {
    getCacheById() {
      let that = this
      if (that.user.AreaCode && that.user.Id) {
        let data = that.user
        that.$post(that.$interface.GetActivityDetail, data).then(res => {
          if(res.Result!=0){
            that.activtyData.ActivityType=res.Data.ActivityType
            that.activtyData.Status=res.Data.Status
            that.activtyData.Id=res.Data._id
          }else{

          }
        })
      }
    },
    ShippingFee() {
      let that = this
      let ua = navigator.userAgent.toLowerCase();
      console.log('ua', ua)
      //android终端
      let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1 || ua.indexOf('android') > -1 || ua.indexOf('adr') > -1;
      console.log('isAndroid', isAndroid)
      //ios终端
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

      let data = that.activtyData
      if (!isAndroid) {
        //ios
        console.log(" 我是ios")
        //这里是和IOS商量好的写法，调用IOS的finishActivity方法
        try {
          window.webkit.messageHandlers.GetActivityDetail.postMessage(data)
        } catch (error) {
          console.log('WKWebView post message');
        }
      } else if (isAndroid) {
        //android
        console.log("我是android", JSON.stringify(data));
        //这里是和安卓商量好的写法，调用安卓的finishActivity方法
        //android.PayCallback('我是android测试传值');           
        android.GetActivityDetail(JSON.stringify(data));
      }
    }
  },
}

</script>
<style scoped>
.oversea img {
  width: 100%;
  display: block;
  overflow: hidden;
}

.oversea>div.btn {
  position: relative;
  width: 200px;
  height: 50px;
  background: #f00;
  color: #fff;
  text-align: center;
  line-height: 50px;
  margin-left: 45vw;
  margin-top: 45vh;
}

</style>



// WEBPACK FOOTER //
// src/components/activity/appactivitydetail.vue